// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { i18n } from '../../domain/index'
import { playSound } from '../sound'
import { SnoozeDialog } from './SnoozeDialog'
import css from './reminder.css'
import { DisplayedReminder } from './types'

interface Props {
  readonly reminders?: DisplayedReminder[]
  readonly closeModal: () => void
  readonly snooze: (minutes: number) => void
  readonly isMuted?: boolean
}

export default function Reminder(props: Props) {
  const { reminders = [], closeModal, snooze, isMuted = false } = props

  const [isSnoozeDialogOpen, setIsSnoozeDialogOpen] = useState(false)

  const closeSnoozeDialog = () => {
    setIsSnoozeDialogOpen(false)
  }

  const openSnoozeDialog = () => {
    setIsSnoozeDialogOpen(true)
  }

  useEffect(() => {
    const isAllRemindersMuted = reminders.every((reminder) => reminder.muted)
    if (reminders.length > 0 && !isMuted && !isAllRemindersMuted) {
      playSound('newOrder')
    }
  }, [reminders, isMuted])

  return (
    <Dialog
      open={reminders.length > 0}
      keepMounted
      onClose={() => closeModal()}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
      fullWidth
      maxWidth='sm'
      PaperProps={{
        sx: {
          maxHeight: '90vh',
          margin: { xs: '16px', sm: '32px' },
        },
      }}
    >
      <div className={css.centered}>
        <DialogTitle id='alert-dialog-slide-title' className={css.bigtitle}>
          {i18n.t('admin.reminders.reminder')}
        </DialogTitle>
        <DialogContent className={css.reminderContent}>
          <List>
            <DialogContentText>
              {reminders.map((reminder) => (
                <ListItem className={css.bigcontent} key={reminder.id}>
                  {reminder.name}
                </ListItem>
              ))}
            </DialogContentText>
          </List>
        </DialogContent>
        <DialogActions className={css.alertDialogSlideActions}>
          <Button onClick={() => closeModal()} color='primary' variant='contained'>
            {i18n.t('buttons.close')}
          </Button>
          <Button onClick={openSnoozeDialog} color='default' variant='contained'>
            {i18n.t('admin.reminders.snooze')}
          </Button>
        </DialogActions>
        <SnoozeDialog isOpen={isSnoozeDialogOpen} onCancel={closeSnoozeDialog} onSnooze={snooze} />
      </div>
    </Dialog>
  )
}
